import { render } from "./ListItems.vue?vue&type=template&id=2bbb7b4d&scoped=true"
import script from "./ListItems.vue?vue&type=script&lang=js"
export * from "./ListItems.vue?vue&type=script&lang=js"

import "./ListItems.vue?vue&type=style&index=0&id=2bbb7b4d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2bbb7b4d"

export default script